
namespace TabAurous.Inventory {

    @Serenity.Decorators.registerClass()
    export class RejectionItemsSelectGrid extends _Ext.GridBase<RejectionItemsRow, any> {
        protected getColumnsKey() { return 'Inventory.RejectionItems'; }
        protected getDialogType() { return <any>RejectionItemsDialog; }
        protected getIdProperty() { return RejectionItemsRow.idProperty; }
        //protected getLocalTextPrefix() { return RejectionItemsRow.localTextPrefix; }
        protected getService() { return JobWorkRejectionItemsService.baseUrl; }
  
        constructor(container: JQuery, options) {
            super(container, options); 
            new Serenity.HeaderFiltersMixin({
                grid: this
            });
            return this;
        }

        private autoSize;
         
        // *** Resizes the columns after changes are made to the grid (ex. Column Picker) *
        protected markupReady() {
            super.markupReady();
            if (this.autoSize != null) {
                this.autoSize.resizeAllColumns();
            }
        }

        get selectedItems(): RejectionItemsRow[] {
            var _this = this;
            return this.rowSelection.getSelectedAsInt32().map(function (x) { return _this.view.getItemById(x); });
        }

        protected usePager() { return false; };
        protected getInitialTitle() { return null; };

        protected getButtons() {
            var buttons = super.getButtons.call(this);
            buttons = buttons.filter(function (x) { return x.cssClass != 'add-button'; });
            return buttons;
        };


        protected onViewSubmit() {

            if (!super.onViewSubmit.call(this))
                return false;
            //var request = this.view.params;
            //if (this.options.hideProducts && this.options.hideProducts.length)
            //    request.Criteria = Serenity.Criteria.and(request.Criteria, [["ProductID" /* ProductID */], 'not in', [this.options.hideProducts]]);
            return true;

        }

    } 
}